import { Tab } from '@aibees/shared/components';
import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { TabContext } from '@mui/lab';
import { Tabs } from '@mui/material';
import { memo } from 'react';
import { tabs } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { TemplateVisibilityTabsProps as Props } from './types';

export const TemplateVisibilityTabs = memo(
  ({ className, onChange, tabValue, size, counts, LabelVariant }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('TemplateVisibilityTabs', className)}
        sx={SX.root}
      >
        <TabContext value={tabValue}>
          <Tabs
            onChange={onChange}
            value={tabValue}
            key={tabValue}
            variant="fullWidth"
            size={size ?? 'medium'}
            textColor="primary"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                LabelContent={fHumanReadableNumber(counts[tab.value])}
                LabelVariant={LabelVariant}
              />
            ))}
          </Tabs>
        </TabContext>
      </Styled.Wrapper>
    );
  }
);

TemplateVisibilityTabs.displayName = 'TemplateVisibilityTabs';
